import { Tooltip, Typography } from '@mui/material';
import { Status } from '@cw-ui/data-display-components';
import { formatMessage } from 'src/i18n/intl';
import size from 'lodash/size';
import calculateStatus from 'src/features/users-v2/utils/Userutils';
import Locale from 'src/i18n';
import {
    ACTIVE,
    AUTH_MFA,
    CONNECTED_APPS,
    DISABLED,
    DUO_MFA,
    EMAIL,
    EMAIL_MFA,
    EXPIRED,
    filterOperators,
    FIRST_NAME,
    LAST_NAME,
    LOGIN_SCHEME,
    MFA_PROVIDERS,
    PENDING,
    SINGLE_SELECT,
    STATUS,
    USER_ROLES,
} from 'src/features/users-v2/constants';
import UserRolesColumn from 'src/features/users-v2/components/UserRolesColumn/UserRolesColumn';

export const getGridColumnData = ({
    isReadOnlyOrEmbedded,
    hideIdentityRoles,
    identityRoles,
    loginProvidersFilter,
    isDownThanLgScreen,
    readOnlyMode,
    embedded,
}) => {
    const gridColumnData = [
        {
            field: (FIRST_NAME, LAST_NAME),
            headerName: formatMessage(Locale.name),
            flex: 2,
            sortable: !isReadOnlyOrEmbedded,
            hideable: !isReadOnlyOrEmbedded,
            filterable: !isReadOnlyOrEmbedded,
            renderCell: ({ row: { firstName, lastName } }) => {
                return (
                    <Tooltip type="standard" title={`${firstName} ${lastName}`} arrow>
                        <Typography variant="tableCell" noWrap>{`${firstName} ${lastName}`}</Typography>
                    </Tooltip>
                );
            },
        },
        {
            field: EMAIL,
            headerName: formatMessage(Locale.email),
            flex: 2,
            hideable: !isReadOnlyOrEmbedded,
            sortable: !isReadOnlyOrEmbedded,
            filterable: !isReadOnlyOrEmbedded,
            renderCell: ({ row: { email } }) => {
                return (
                    <Tooltip type="standard" title={email} arrow>
                        <Typography variant="tableCell" noWrap>
                            {email}
                        </Typography>
                    </Tooltip>
                );
            },
        },
        ...(!hideIdentityRoles
            ? [
                  {
                      field: USER_ROLES,
                      headerName: formatMessage(Locale.identityRole),
                      flex: 2,
                      sortable: !isReadOnlyOrEmbedded,
                      hideable: !isReadOnlyOrEmbedded,
                      filterable: !isReadOnlyOrEmbedded,
                      renderCell: ({ row: { userRoles, email } }) => {
                          return <UserRolesColumn userRoles={userRoles} email={email} />;
                      },
                      type: SINGLE_SELECT,
                      filterOperators,
                      valueOptions: [...identityRoles],
                  },
              ]
            : []),
        {
            field: STATUS,
            headerName: formatMessage(Locale.userStatus),
            flex: 1,
            type: SINGLE_SELECT,
            sortable: !isReadOnlyOrEmbedded,
            hideable: !isReadOnlyOrEmbedded,
            filterable: !isReadOnlyOrEmbedded,
            renderCell: ({ row: { status } }) => {
                const [statusValue, statusColor] = calculateStatus(status);

                return <Status color={statusColor} text={statusValue} />;
            },
            valueOptions: [ACTIVE, PENDING, DISABLED, EXPIRED],
            filterOperators,
        },
        {
            field: LOGIN_SCHEME,
            sortable: !isReadOnlyOrEmbedded,
            hideable: !isReadOnlyOrEmbedded,
            filterable: !isReadOnlyOrEmbedded,
            headerName: formatMessage(Locale.authentication),
            type: SINGLE_SELECT,
            valueOptions: [...loginProvidersFilter],
            filterOperators,
        },
        {
            field: MFA_PROVIDERS,
            sortable: !isReadOnlyOrEmbedded,
            hideable: !isReadOnlyOrEmbedded,
            headerName: formatMessage(Locale.mfaProviders),
            type: SINGLE_SELECT,
            valueOptions: [EMAIL_MFA, AUTH_MFA, DUO_MFA],
            filterOperators,
            // filterable: mfaProvidersFilterable && !isReadOnlyOrEmbedded,
        },
    ];

    const connectedAppsColumn = {
        field: CONNECTED_APPS,
        headerName: formatMessage(Locale.noOfConnectedApps),
        flex: 1,
        sortable: !isReadOnlyOrEmbedded,
        hideable: !isReadOnlyOrEmbedded,
        filterable: !isReadOnlyOrEmbedded,
        renderCell: ({ row: { connectedApps } }) => {
            return <Typography variant="tableCell">{size(connectedApps)}</Typography>;
        },
    };

    return {
        gridColumnData,
        connectedAppsColumn,
    };
};
